import React from 'react';
import {
  cancelVendorInvoiceVesselSend,
  vesselSendCancelErrorMessage,
  type VesselSendCancelResult,
} from '../../lib/vendorInvoiceApi';

/**
 * D113.10 (owner, 2026-10-12) — "Cancel send" on one vessel of the split modal.
 *
 * Shown on a row that is Sent or Partly sent. Asks first; on success the page
 * clears the row's stamp so it reads "Not yet sent" (the server already has).
 * A refusal is worded from its code (vesselSendCancelErrorMessage).
 */
export default function VesselCancelSendButton({
  invoiceId,
  allocationId,
  vesselName,
  lineCount,
  locationLabel,
  disabled = false,
  onBusy,
  onCancelled,
  onError,
}: {
  invoiceId: string;
  allocationId: string;
  vesselName: string;
  /** Lines on the vessel now, for the question. */
  lineCount: number;
  /** The stock they go back to, e.g. "Ship Chandlery". */
  locationLabel: string;
  disabled?: boolean;
  onBusy: (busy: boolean) => void;
  onCancelled: (result: VesselSendCancelResult) => void;
  onError: (message: string) => void;
}) {
  const run = async () => {
    const lines = `${lineCount} line${lineCount === 1 ? ' goes' : 's go'}`;
    if (!window.confirm(`Cancel the send to ${vesselName}? Its ${lines} back to ${locationLabel} stock.`)) return;
    onBusy(true);
    try {
      const res = await cancelVendorInvoiceVesselSend(invoiceId, allocationId);
      onCancelled(res.data);
    } catch (e) {
      onError(vesselSendCancelErrorMessage(e));
    } finally {
      onBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={run}
      disabled={disabled}
      title={`Take ${vesselName}'s goods back into ${locationLabel} stock so the split can be changed`}
      className="shrink-0 px-2 py-1.5 text-xs font-semibold rounded border border-rose-300 text-rose-700 bg-white hover:bg-rose-50 disabled:opacity-40 whitespace-nowrap"
    >
      Cancel send
    </button>
  );
}
